import { FC, useContext, useState } from "react";
import { TranslationContext } from "../../context/TranslationContext";
import useSearch from "../../hooks/useSearch";

type Props = {
  value: number;
  handleChange: (value: string) => void;
};

type LastVisitOption = {
  id: number;
  title: string;
  selected: boolean;
};

const LastActiveFilter: FC<Props> = ({ value, handleChange }) => {
  const { i } = useContext(TranslationContext);
  const { filteredSearch } = useSearch();

  const [selected, setSelected] = useState<string>(
    filteredSearch.lastVisitedDate
  );

  const onSelectionChange = (value: string) => {
    setSelected(value);
    handleChange(value);
  };

  const lastVisitOptions: LastVisitOption[] = [
    {
      id: 0,
      title: i("All"),
      selected: selected === "0",
    },
    {
      id: 1,
      title: i("Less than a week"),
      selected: selected === "1",
    },
    {
      id: 2,
      title: i("Less than a month"),
      selected: selected === "2",
    },
  ];
  return (
    <div className="LastActiveFilter flex flex-row">
      <label className="text-base font-bold text-custom-black mr-2.5">
        {i("Last visit")}:
      </label>
      <fieldset>
        <legend className="sr-only">{i("Last visit")}</legend>
        <div className="space-y-4">
          {lastVisitOptions.map((lastVisitOption) => (
            <LastVisitOption
              {...lastVisitOption}
              key={lastVisitOption.id}
              value={value}
              handleChange={onSelectionChange}
            />
          ))}
        </div>
      </fieldset>
    </div>
  );
};

function LastVisitOption({
  id,
  title,
  value,
  selected,
  handleChange,
}: LastVisitOption & { value: number; handleChange: (value: string) => void }) {
  return (
    <div key={id} className="flex items-center">
      <input
        id={id.toString()}
        type="radio"
        name="Last visit"
        className="hidden"
        checked={selected}
        onChange={(event) => {
          handleChange(event.target.id);
        }}
      />
      <label
        htmlFor={id.toString()}
        className="flex items-center cursor-pointer text-base text-custom-black"
      >
        <span className="w-[26px] h-[26px] inline-block text-custom-light-blue border border-custom-gray rounded-full mr-2"></span>
        {title}
      </label>
    </div>
  );
}

export default LastActiveFilter;
